import React from 'react';

const btnPinkSmall = (props) => {
  return (
    <button type='submit' className='btn-pink' onClick={props.onclick}>
      <span className='btn-pink-text'>{props.text}</span>
    </button>
  );
};

export default btnPinkSmall;
